import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const FormTextField = ({
  label,
  required,
  value,
  onChange,
  error,
  type = "text",
  placeholder,
  multiline = false,
  rows,
  maxLength,
}) => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 12.5,
          fontWeight: 650,
          color: "#3A4441",
          mb: 0.75,
        }}
      >
        {label}

        {required && (
          <Box component="span" sx={{ color: "error.main" }}>
            {" "}
            *
          </Box>
        )}
      </Typography>

      <TextField
        fullWidth
        size="small"
        type={type}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        error={Boolean(error)}
        helperText={error || " "}
        placeholder={placeholder}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        inputProps={{
          maxLength,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,

            "& fieldset": {
              borderColor: "#E6ECEA",
            },

            "&:hover fieldset": {
              borderColor: "#0E7A6E",
            },

            "&.Mui-focused fieldset": {
              borderColor: "#0E7A6E",
            },
          },
        }}
      />
    </Box>
  );
};

export default FormTextField;
